<template>
  <div class="statistic">
    <div class="filters">
      <div class="row">
        <div class="time" @click="clickDate">
          <span>日期：</span>
          <span>{{ time }}</span>
          <img
            class="pull-icon"
            :class="{reverse: showTimer}"
            src="@/assets/image/pull.png"
          />
        </div>

        <div class="total d-flex">
          <div
            v-for="item in typeOptions"
            :key="item.value"
            :class="{
              active: true,
              record: item.value === 0,
              reprint: item.value === 1
            }"
          >
            {{ item.name }}: {{ item.value === 0 ? totalRecord : totalReprintRecord }}
          </div>
        </div>
      </div>
      <div class="row" v-show="showTimer">
        <div
          class="time-selector"
          :class="{ active: selectedTime.value === time.value }"
          v-for="time in timeOptions"
          :key="time.value"
          @click="switchTime(time)"
        >
          {{ time.name }}
        </div>
      </div>
    </div>
    
    <div class="echarts-wrapper">
      <van-swipe
        indicator-color="#44D0C9"
        @change="onChangeSwipe"
      >
        <van-swipe-item>
          <Echart
          :config="printCountData"
        />
        </van-swipe-item>

        <van-swipe-item>
          <Echart
            :config="printProportionData"
          />
        </van-swipe-item>

        <van-swipe-item
          v-if="
            workloadData.dataset && 
            workloadData.dataset.source && 
            workloadData.dataset.source.length > 1 "
        >
          <Echart
            :config="workloadData"
          />
        </van-swipe-item>

        <van-swipe-item
          v-if="
            packagePrintData.xAxis && 
            packagePrintData.xAxis.data && 
            packagePrintData.xAxis.data.length
          "
        >
          <Echart
            :config="packagePrintData"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import {
  getPrintCount
} from '@/api/tag';
import {
  getCountByDay,
  getPrintRecordProportion,
  getUserWorkload,
  getPackagePrintCount
} from '@/api/statistic';
import Echart from '@/components/echarts/index';
export default {
  name: 'Statistic',
  components: {
    Echart
  },
  computed: {
    time() {
      const { value, name } = this.selectedTime
      let time = ''
      switch (value) {
        case 1:
          time = this.$moment().format('yyyy/MM/DD')
          break;
        case 2:
          time = this.$moment().subtract(1, 'days').format('yyyy/MM/DD')
          break;
        case 3:
          time = name
          break;
        case 4:
          time = name
          break;
      }

      return time
    }
  },
  data() {
    return {
      showTimer: false,
      timeOptions: [
        {
          name: '今天',
          value: 1
        },
        {
          name: '昨天',
          value: 2
        },
        {
          name: '本周',
          value: 3
        },
        {
          name: '上周',
          value: 4
        }
      ],
      typeOptions: [
        {
          name: '常规打印总数',
          value: 0
        },
        {
          name: '补打总数',
          value: 1
        }
      ],
      selectedTime: {},
      totalRecord: 0,
      totalReprintRecord: 0,
      printCountData: {},
      printProportionData: {},
      workloadData: {},
      packagePrintData: {}

    }
  },
  mounted(){
    this.pageEnterTime = new Date().getTime();
  },
  methods: {
    onChangeSwipe(data){
      var pageLeaveTime = new Date().getTime();
      var stayDuration = pageLeaveTime - this.pageEnterTime;
      window._hmt && _hmt.push(['_trackEvent', '打印统计的系统指标停留时长', 'stay', '/record', JSON.stringify(this.user) +','+ stayDuration+','+data]);
      this.pageEnterTime = new Date().getTime();
    },
    clickDate(){
      this.showTimer = !this.showTimer
      window._hmt && _hmt.push(['_trackEvent', '打印统计中的时间 按钮', 'click']);
    },
    init() {
      this.selectedTime = this.timeOptions[0]
      this.search()
      this.getPrintTotalCount()
    },
    getTimeRange() {
      // 根据时间范围获取时间段
      const {
        value
      } = this.selectedTime
      let start = undefined
      let end = undefined
      switch (value) {
        case 1:
          start = this.$moment().startOf('day').format('yyyy-MM-DD')
          end = this.$moment().endOf('day').format('yyyy-MM-DD')
          break;
        case 2:
          start = this.$moment().subtract(1, 'days').startOf('day').format('yyyy-MM-DD')
          end = this.$moment().subtract(1, 'days').endOf('day').format('yyyy-MM-DD')
          break;
        case 3:
          const week = this.$moment().week()
          start = this.$moment().week(week).startOf('week').format('yyyy-MM-DD')
          end = this.$moment().week(week).endOf('week').format('yyyy-MM-DD')
          break;
        case 4:
          const lastWeek = this.$moment().subtract(1, 'weeks')
          start = lastWeek.startOf('week').format('yyyy-MM-DD')
          end = lastWeek.endOf('week').format('yyyy-MM-DD')
          break;
      }

      return [start, end]
    },
    getPrintTotalCount() {
      // 获取打印总数
      const time = this.getTimeRange()
      const query = {
        start: time[0],
        end: time[1]
      }

      getPrintCount(query)
      .then(res => {
        if (res) {
          const {
            total,
            add_number
          } = res

          this.totalRecord = total - add_number
          this.totalReprintRecord = add_number
        }
      })
    },
    search() {
      // 查询统计
      this.getPrintCount()
      this.getPrintProportion()
      this.getWorkload()
      this.getPackageData()
    },
    getPrintCount() {
      const time = this.getTimeRange()
      const query = {
        start: time[0],
        end: time[1]
      }

      getCountByDay(query)
      .then(res => {
        this.printCountData = this.makeCountDataForEcharts(res)
      })
    },
    makeCountDataForEcharts(data) {
      // 整理每日标签打印数量图片
      const xData = [];
      const data1 = [];
      const data2 = [];
      for (let key in data) {
        xData.push(key);
        data1.push(data[key].add_number);
        data2.push(data[key].number);
      }

      return {
        title: {
          text: '每日标签打印数量变化',
          x: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [
            '常规打印数量',
            '补打数量'
          ],
          bottom: '1%'
        },
        grid: {
          left: "6%",
          right: "2%",
          bottom: "10%",
          top: '16%',
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: ['10%'],
          data: xData,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          axisLabel: {
            formatter: function (value) {
              if (value % 1 == 0) {
                return value;
              }
            },
          },
        },
        series: [
          {
            name: '补打数量',
            type: "line",
            // stack: "Total",
            data: data1,
            color: '#01BBEE'
          },
          {
            name: '常规打印数量',
            type: "line",
            // stack: "Total",
            data: data2,
            color: '#44D0C9'
          },
        ],
      }
    },
    getPrintProportion() {
      const time = this.getTimeRange()
      const query = {
        start: time[0],
        end: time[1]
      }

      getPrintRecordProportion(query)
      .then(res => {
        this.printProportionData = this.makeProportionDataForEcharts(res)
      })
    },
    makeProportionDataForEcharts(data) {
      // 整理标签打印占比图表数据
      const newData = [
        { value: data.total - data.add_number, name: '常规打印数量' },
        { value: data.add_number, name: '补打数量' }
      ];

      return {
        title: {
          text: '标签补打记录占比',
          x: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "1%",
          left: "center",
        },
        color: ['#44D0C9', '#01BBEE'],
        series: [
          {
            name: '标签补打记录占比',
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true, // 显示标签
              position: "inside", // 标签位置：在柱子内部
              fontWeight: "bold",
              formatter: function (params) { // 计算百分比
                if(params.data.value == 0){
                  return ''
                }else{
                  let percentage = (params.data.value / data.total) * 100;
                  return percentage.toFixed(1) + '%';
                }
                
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: newData
          },
        ],
      }
    },
    getWorkload() {
      const time = this.getTimeRange()
      const query = {
        start: time[0],
        end: time[1]
      }

      getUserWorkload(query)
      .then(res => {
        this.workloadData = this.makeWorkloadDataForEcharts(res)
      })
    },
    makeWorkloadDataForEcharts(data) {
      const newData = [];
      newData.push(['honjo', '组配人', '包装人']);
      for (let i = 0; i < 10; i++) {
        for (let key in data) {
          newData.push([
            key.split("_")[0],
            data[key].pack_number,
            data[key].package_number,
          ]);
        }
      }
      
      return {
        title: {
          text: '工作人员工作量',
          x: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: "item",
        },
        grid: {
          height: '66%'
        },
        legend: {
          bottom: '0%'
        },
        dataset: {
          source: newData,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisLabel: {
            rotate: 45,
            formatter: function(value) {
              if (value.length >= 5) {
                return `${value.substring(0, 5)}...`
              }

              return value
            }
          }
        },
        yAxis: {
          axisLine: {
            show: true
          },
          axisLabel: {
            formatter: function (value) {
              // 格式化刻度标签，将小数部分去除
              if (value % 1 == 0) {
                return value;
              }
            },
          },
        },
        color: ['#FACA00', '#6FC208'],
        series: [
          {
            type: "bar",
            label: {
              show: true, // 显示标签
              // color: '#fff',
              position: "inside", // 标签位置：在柱子内部
              formatter: function (params) {
                if (params.value[1] !== 0) {
                  return params.value[1];
                } else {
                  return ""; // 数据为零时返回空字符串，不显示标签
                }
              },
            },
            barMaxWidth: 30, // 设置最大宽度为20px
          },
          {
            type: "bar",
            label: {
              show: true, // 显示标签
              position: "inside", // 标签位置：在柱子内部
              formatter: function (params) {
                if (params.value[2] !== 0) {
                  return params.value[2];
                } else {
                  return ""; // 数据为零时返回空字符串，不显示标签
                }
              },
            },
            barMaxWidth: 30, // 设置最大宽度为20px
          },
        ]
      }
    },
    getPackageData() {
      const time = this.getTimeRange()
      const query = {
        start: time[0],
        end: time[1]
      }

      getPackagePrintCount(query)
      .then(res => {
        this.packagePrintData = this.makePackageDataForEcharts(res)
      })
    },
    makePackageDataForEcharts(data) {
      const xData = [];
      const seriesData = [];
      for (let key in data) {
        xData.push(key);
        seriesData.push(data[key]);
      }
      
      return {
        title: {
          text: '打印器械包数量',
          x: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: "item",
        },
        grid: {
          height: '64%'
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            rotate: 45,
            formatter: function(value) {
              if (value.length >= 10) {
                return `${value.substring(0, 10)}...`
              }

              return value
            }
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            formatter: function (value) {
              // 格式化刻度标签，将小数部分去除
              if (value % 1 == 0) {
                return value;
              }
            },
          },
          axisLine: {
            show: true
          }
        },
        color: ['#AB7DF6'],
        series: [
          {
            data: seriesData,
            type: "bar",
            label: {
              show: true, // 显示标签
              position: "inside", // 标签位置：在柱子内部
              fontWeight: "bold",
              formatter: function (params) {
                if (params.value[1] !== 0) {
                  return params.value[1];
                } else {
                  return ""; // 数据为零时返回空字符串，不显示标签
                }
              },
            },
            barMaxWidth: 30, // 设置最大宽度为20px
          },
        ],
      }
    },
    switchTime(time) {
      this.selectedTime = time
      this.showTimer = false
      this.search()
      this.getPrintTotalCount()
    },
  },
  created() {
    this.init()
    window._hmt && _hmt.push(['_trackEvent', '打印统计按钮', 'click', JSON.stringify(this.user)]);
  }
}
</script>

<style lang="less" scoped>
  .statistic {
    .filters {
      padding: 0 64px;
      .row {
        margin: 12px 0 0;
        display: flex;
        justify-content: space-between;
        .time {
          font-size: 42px;
          display: flex;
          align-items: center;
          color: @primary-font-color-1;
        }
        .time-selector {
          width: 240px;
          height: 100px;
          line-height: 100px;
          text-align: center;
          color: #fff;
          border-radius: 6px;
          font-size: 48px;
          &.active {
            background-color: rgba(255, 255, 255, 0.3);
            color: #fff;
          }
        }
        .pull-icon {
          width: 44px;
          height: 44px;
          margin: 0 0 0 20px;
          transform: rotate(180deg);
          &.reverse {
            transform: rotate(0deg);
          }
        }
        .total {
          // gap: 14px;
          .flexgap(14px, row);
        }
        .record, .reprint {
          height: 64px;
          line-height: 64px;
          color: #fff;
          border-radius: 4px;
          font-size: 36px;
          padding: 0 20px;
        }
        .record {
          color: @primary-color-1;
          &.active {
            color: #fff;
            background-color: @primary-color-1;
          }
        }
        .reprint {
          color: @primary-color-2;
          &.active {
            color: #fff;
            background-color: @primary-color-2;
          }
        }
      }
    }

    .echarts-wrapper {
      padding: 0 64px;
      margin: 20px 0;
      .e-chart {
        margin: 160px 0;
      }
    }
  }
</style>